<template>
  <section
    class="course-listing-banner-section gradiant-banner"
    v-if="liveCourses.length > 0"
  >
    <b-container>
      <b-navbar toggleable="md" type="dark" class="course-listing-banner-nav">
        <b-navbar-brand href="#">Live {{ course_name }} courses</b-navbar-brand>

        <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>

        <!--<b-collapse id="nav-collapse" is-nav>-->
        <!--&lt;!&ndash; Right aligned nav items &ndash;&gt;-->
        <!--<filter-bar :filter-data="filterData"></filter-bar>-->
        <!--</b-collapse>-->
      </b-navbar>
    </b-container>
    <b-container style="height: 340px;">
      <banner-slider :slides="1" :liveCourses="liveCourses"></banner-slider>
    </b-container>
  </section>
</template>

<script>
import FilterBar from "../Templates/FilterBar";
import BannerSlider from "../Templates/BannerSlider";
export default {
  name: "CourseListingBanner",
  components: {
    FilterBar,
    BannerSlider
  },
  data() {
    return {
      tinySliderOptions: {
        mouseDrag: true,
        loop: false,
        items: 4,
        gutter: 20,
        swipeAngle: 45,
        controls: true,
        responsive: {
          640: {
            edgePadding: 20,
            items: 3
          },
          1200: {
            items: 4
          }
        }
      },
      imageArray: ["img/courselistbg.png"]
    };
  },
  props: {
    course_name: String,
    liveCourses: Array,
    filterData: Object
  }
};
</script>

<style></style>
